import { Component, OnDestroy, OnInit } from '@angular/core';
import { GeneralsService } from '@core/services/generals.service';
import { Constants } from '@shared/class/constants.class';
import { Breadcrumb } from '@shared/interfaces/breadcrumb';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnInit, OnDestroy {
  public constants = new Constants();

  public breadcrumbs: Array<Breadcrumb> = [];
  public actions = false;

  constructor(public generalsService: GeneralsService) {}

  ngOnInit() {
    this.generalsService.breadcrumb$
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        this.breadcrumbs = result;
      });

    this.generalsService.action$
      .pipe(takeUntil(this.constants.destroy$))
      .subscribe((result: any) => {
        this.actions = result;
      });
  }

  ngOnDestroy() {
    this.constants.destroy$.next(true);
    this.constants.destroy$.unsubscribe();
  }
}
